module.exports = __webpack_public_path__ + "img/purpleCarnival.04df5441.png";